import Vue from 'vue'

const state = {
  users_columns: [],
  live_classes_columns: [],
  trainings_columns: [],
  trails_columns: [],
  drills_columns: [],
  presential_columns: [],
  webcasts_columns: [],
  podcasts_columns: []
}

const actions = {
    SET_USERS_COLUMNS(context, [users_columns]) {
        context.commit('SAVE_USERS_COLUMNS', [users_columns])
    },
    SET_LIVE_CLASSES_COLUMNS(context, [live_classes_columns]) {
      context.commit('SAVE_LIVE_CLASSES_COLUMNS', [live_classes_columns])
    },
    SET_TRAININGS_COLUMNS(context, [trainings_columns]) {
      context.commit('SAVE_TRAININGS_COLUMNS', [trainings_columns])
    },
    SET_TRAILS_COLUMNS(context, [trails_columns]) {
      context.commit('SAVE_TRAILS_COLUMNS', [trails_columns])
    },
    SET_DRILLS_COLUMNS(context, [drills_columns]) {
      context.commit('SAVE_DRILLS_COLUMNS', [drills_columns])
    },
    SET_PRESENTIAL_COLUMNS(context, [presential_columns]) {
      context.commit('SAVE_PRESENTIAL_COLUMNS', [presential_columns])
    },
    SET_WEBCASTS_COLUMNS(context, [webcasts_columns]) {
      context.commit('SAVE_WEBCASTS_COLUMNS', [webcasts_columns])
    },
    SET_PODCASTS_COLUMNS(context, [podcasts_columns]) {
      context.commit('SAVE_PODCASTS_COLUMNS', [podcasts_columns])
    }
}

const mutations = {
    SAVE_USERS_COLUMNS: (state, [users_columns]) => {
        Vue.set(state, 'users_columns', users_columns)
    },
    SAVE_LIVE_CLASSES_COLUMNS: (state, [live_classes_columns]) => {
      Vue.set(state, 'live_classes_columns', live_classes_columns)
    },
    SAVE_TRAININGS_COLUMNS: (state, [trainings_columns]) => {
      Vue.set(state, 'trainings_columns', trainings_columns)
    },
    SAVE_TRAILS_COLUMNS: (state, [trails_columns]) => {
      Vue.set(state, 'trails_columns', trails_columns)
    },
    SAVE_DRILLS_COLUMNS: (state, [drills_columns]) => {
      Vue.set(state, 'drills_columns', drills_columns)
    },
    SAVE_PRESENTIAL_COLUMNS: (state, [presential_columns]) => {
      Vue.set(state, 'presential_columns', presential_columns)
    },
    SAVE_WEBCASTS_COLUMNS: (state, [webcasts_columns]) => {
      Vue.set(state, 'webcasts_columns', webcasts_columns)
    },
    SAVE_PODCASTS_COLUMNS: (state, [podcasts_columns]) => {
      Vue.set(state, 'podcasts_columns', podcasts_columns)
    }
}

const getters = {
    users_columns: state => {
      return state.users_columns
    },
    live_classes_columns: state => {
      return state.live_classes_columns
    },
    trainings_columns: state => {
      return state.trainings_columns
    },
    trails_columns: state => {
      return state.trails_columns
    },
    drills_columns: state => {
      return state.drills_columns
    },
    presential_columns: state => {
      return state.presential_columns
    },
    webcasts_columns: state => {
      return state.webcasts_columns
    },
    podcasts_columns: state => {
      return state.podcasts_columns
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
